import React, { useEffect, useState } from 'react'
import { Collapse, Icon } from '@blueprintjs/core'
import { Card } from '../../components/ui/card'
import classNames from 'classnames'
import { money } from '../../util/formatters'
import { axiosGet } from '../../util/api'
import qs from 'qs'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from './../../../../tailwind.config.js'
import { useUser } from '../../hooks/useUser'
import { Plan } from '../../types/billing'
import { Layout } from '../../components/Layout'
import { Link } from 'react-router-dom'
import { Marketplace, Marketplaces } from '../../util/marketplaces'

const fullConfig = resolveConfig(tailwindConfig)

const breadcrumbs = (
    <b className="text-lg">
        <Link to="/billing">Billing</Link>&nbsp;› Add coins to your coin jar
    </b>
)

export const AdSpendCredit = () => {
    const [session, setSession] = useState(null)
    const [plan, setPlan] = useState(null)
    const [loading, setLoading] = useState(false)

    const { user } = useUser()

    const loadPlans = (params) => {
        return axiosGet('billing/plans', params)
    }

    console.log('Plan is', plan)

    useEffect(() => {
        const { session_id } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
        console.log(
            'Session id is',
            session_id,
            qs.parse(window.location.search, { ignoreQueryPrefix: true }),
        )

        if (session_id) {
            axiosGet(`billing/ad-spend-credit/session?session_id=${session_id}`)
                .then((res) => {
                    setSession(res.data)
                })
                .catch((res) => {
                    console.log('res is', res)
                })
        }

        setLoading(true)
        loadPlans({})
            .then((res) => {
                setPlan(new Plan(res.data.prepaid))
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }, [])

    if (!plan) {
        return null
    }

    const m = Marketplaces[Marketplace.UnitedStates]

    return (
        <Layout primary={breadcrumbs}>
            <div className="max-w-3xl mx-auto" align="left">
                <Card className="p-0 bp4-card-rounded minimal">
                    <div className="mx-4 flex flex-col">
                        <div>
                            {session && (
                                <div className="px-4 py-3 bg-green-100 border-green-300 border-2 rounded">
                                    <Icon
                                        icon={
                                            <Icon
                                                icon="tick"
                                                color={fullConfig.theme.colors.green[500]}
                                                className="mr-2"
                                            />
                                        }
                                    />
                                    {money(session.metadata.ad_spend, m)} in Merch Jar coins have
                                    been added to your account
                                </div>
                            )}

                            <div className="py-3">
                                <Icon icon={<Icon icon="dollar" className="mr-2" />} />
                                Your coin jar: {money(user?.ad_spend_credits, m)}
                            </div>

                            <h2 className="mt-4 text-lg font-semibold border p-4 bg-red-50 border-red-300 rounded-md shadow-md">
                                Coin bundles are in the process of being phased out and are not
                                available at this time.
                            </h2>
                        </div>
                        <div className="pr-4 mt-10">
                            <p>
                                Merch Jar coins give you a convenient way to prepay anticipated ad
                                spend. Ad spend credits offer you an additional savings over normal
                                pricing.
                            </p>

                            <Faq
                                question="What is a coin?"
                                answer={
                                    <div>
                                        <div className="mb-2">
                                            Coins are Merch Jar's currency that's used to determine
                                            your subscription price. Every $1 USD spent on ads is
                                            the equivalent of 1 Merch Jar Coin.
                                        </div>
                                        <div>
                                            If you spend $5000 in ads through your Merch Jar
                                            connected Amazon Advertising accounts, you'll use 5000
                                            coins.
                                        </div>
                                    </div>
                                }
                            />
                            <Faq
                                question="What are free coins?"
                                answer="Your Merch Jar subscription includes free coins you can use every single month. These coins are used first each month and expire at the end of the billing cycle."
                            />
                            <Faq
                                question="What is my Coin Jar?"
                                answer="Think of your Coin Jar as a kind of a bank, but unlike your free coins, the coins in your Coin Jar never expire. You can add coins to your Coin Jar by performing tasks like referring friends, or purchase Coin Bundles for discounted rates. Coins in your Coin Jar never expire and are only used when you've used all of your free coins."
                            />
                            <Faq
                                question="What happens if I use all of my free coins?"
                                answer={
                                    <div>
                                        <div className="mb-2">
                                            If you're out of free coins for the month, you'll next
                                            use coins from your Coin Jar balance. If you're out of
                                            free coins and your Coin Jar is empty, you'll simply pay
                                            for any additional coins used at the end of the billing
                                            cycle.
                                        </div>
                                        <div className="mb-2">
                                            As an example, if you have
                                            <ul className="ml-4 list-disc mb-0">
                                                <li>$10k in ad spend,</li>
                                                <li>
                                                    are on a plan that includes 2,000 free coins,
                                                </li>
                                                <li>and have 5000 coins in your Coin Jar</li>
                                            </ul>
                                            then Merch Jar will calculate your billable ad spend as
                                            3000 coins ($10k total spend equals 10,000 coins used,
                                            minus 2000 free coins, minus 5000 Coin Jar coins). Your
                                            final bill would be your base plan price plus a charge
                                            for the 3000 additional coins used.
                                        </div>
                                        <div>
                                            See the
                                            <Link to="/billing"> billing page</Link> for detailed
                                            rates.
                                        </div>
                                    </div>
                                }
                            />
                            <Faq
                                question="Do coins expire?"
                                answer="Nope! Coins in your Coin Jar never expire and are valid forever."
                            />
                            <Faq
                                question="Is there a limit to how many coins I can have in my Coin Jar?"
                                answer="Nope! Your Coin Jar can hold an unlimited number of coins"
                            />
                            <Faq
                                question="How are different currencies calculated?"
                                answer="Marketplaces that use currencies other than the US Dollar (USD) will be converted to USD at the current exchange rate on the last day of each billing cycle to calculate coin usage."
                            />
                        </div>
                    </div>
                </Card>
            </div>
        </Layout>
    )
}

const Faq = ({ question, answer }) => {
    const [open, setOpen] = useState(false)

    return (
        <div className="mt-3">
            <div
                className="text-lg font-semibold cursor-pointer flex items-center"
                onClick={() => setOpen(!open)}
            >
                {question}
                <Icon
                    tagName="div"
                    icon={
                        <Icon
                            icon="caret-down"
                            size={18}
                            className={classNames(
                                'ml-3 transform transition transition-duration-1000',
                                {
                                    'rotate-180': open,
                                },
                            )}
                        />
                    }
                />
            </div>
            <Collapse isOpen={open} className="mt-1">
                {answer}
            </Collapse>
        </div>
    )
}
